<div class="carry-forward-preview">
  <div class="carry-forward-header mb-5">
    <h2 class="title is-4">Would you like to carry forward your report from the previous period?</h2>
    <p class="subtitle is-6 has-text-grey">
      Your answers from the previous reporting period are shown below.
      You can confirm them as unchanged or edit them.
    </p>
  </div>

  @if (previousSubmission) {
    <app-questionnaire-review
      [questionnaire]="questionnaire"
      [submission]="previousSubmission"
      [readOnly]="true"
      [hideHeader]="true"
    ></app-questionnaire-review>
  }

  <div class="carry-forward-actions mt-5">
    <a
      (click)="onConfirm()"
      class="button is-link is-medium"
      [ngClass]="{ 'is-loading': loading }"
      [class.is-disabled]="loading"
    >
      Confirm and carry forward
    </a>
    <a
      (click)="onEdit()"
      class="button is-white is-medium ml-3"
    >
      Edit answers
    </a>
    <a
      (click)="onStartFresh()"
      class="button is-white is-medium ml-3"
    >
      Start from scratch
    </a>
  </div>
</div>
